// extracted by mini-css-extract-plugin
module.exports = {"container":"ReferencesInfo_container__T34sp","loader":"ReferencesInfo_loader__g7Q_P"};